export default {
  maxUploadSize: 2 * 1024 * 1024 * 1024, // 2GB (in bytes)
}
